import { z } from 'zod/v4'
import { useMesaDynamicConfig } from '@/src/services/Statsig/useMesaDynamicConfig'

export const PointsToCashForMortgageSchema = z.object({
  MESA_MORTGAGE_TRANSFER_POINT_TO_CENTS_CONVERSION: z.number(),
  MESA_MORTGAGE_TRANSFER_MINIMUM_DOLLAR: z.number(),
  MESA_MORTGAGE_TRANSFER_MAXIMUM_MONTHLY_DOLLAR: z.number(),
  MESA_MORTGAGE_TRANSFER_MAXIMUM_PERIOD_DAYS: z.number(),
  MESA_MORTGAGE_TRANSFER_MAXIMUM_CENTS: z.number(),
})

export type PointsToCashForMortgage = z.infer<typeof PointsToCashForMortgageSchema>

export function usePointsToCashForMortgageDynamicConfig() {
  return useMesaDynamicConfig('mortgage_points_transfer')
}
